export default __webpack_public_path__ + "static/media/Shivansh_dp.84e16894.jpeg";